import { User } from "@common/types/user";
import { userContract } from "@common/contracts/user.contract";
import { UserIntegrationsResponseDto } from "@common/dto/user/user-integrations-response.dto";
import { HandleGoogleAuthDto } from "@common/dto/user/handle-google-auth.dto";
import { z } from "zod";
import {
    UserSchema,
    updateProfileBodySchema,
} from "@common/schemas/user.schema";
import { backendClient, unwrapResponse } from "./backendClient";
import { getBackendAPIClient } from "./backendAPIClient";

const userApiClient = getBackendAPIClient(userContract);

type UpdateProfileData = z.infer<typeof updateProfileBodySchema>;

function toUser(schema: UserSchema): User {
    return {
        ...schema,
        settings: {
            weeklyInsightsEnabledAt:
                schema.settings.weeklyInsightsEnabledAt ?? null,
            monthlyInsightsEnabledAt:
                schema.settings.monthlyInsightsEnabledAt ?? null,
            dailyTasksDigestEnabledAt:
                schema.settings.dailyTasksDigestEnabledAt ?? null,
        },
    };
}

export async function updateProfile(data: UpdateProfileData): Promise<User> {
    const response = await userApiClient.updateProfile({ body: data });
    return toUser(response.body);
}

export async function getUserIntegrations(workspaceId: string) {
    const dto: UserIntegrationsResponseDto = unwrapResponse(
        await backendClient.get("/user/integrations", {
            params: { workspaceId },
        }),
    );

    return UserIntegrationsResponseDto.deserialize(dto);
}

export async function handleGoogleAuth(data: HandleGoogleAuthDto) {
    return unwrapResponse(await backendClient.post("/google-auth", data));
}
